import { CommonUtilities } from '../../commonUtils';

export default class PaymentServices {
    static getClientDetails() {
        var url = 'client/getClientDetails'
        return CommonUtilities.getData(url);
    }

    static async tagColor() {
        var url = 'common/tagColor/listAll';
        return await CommonUtilities.getData(url);
    }

    static async initCheck() {
        var url = 'provider/tipalti/initCheck';
        return await CommonUtilities.getData(url);
    }

    static authInitialisation(param: any) {
        var url = 'provider/tipalti/authInitialisation';
        return CommonUtilities.postData(url, param);
    }

    static authoriseTipalti = function (postData : any) {
        var url =  'provider/tipalti/authorisation';
        return CommonUtilities.postData(url, postData);
    };
 
    static tipaltiInitCheck = function (postData:any ){
        var url =  'provider/tipalti/callback'+postData;
        return CommonUtilities.getData (url);
    };

    static async paymentVendor(clientName :any) {
        var url = 'contract/paymentVendor/list?'+ CommonUtilities.buildQueryString(clientName, true, true);;
        return await CommonUtilities.getData(url);
    }

    static ViewUploadFileLog(Data: {}){
        var url = 'importLog/SearchFileLog/SPY/none?' + Data;
        return CommonUtilities.getData(url);
    }



}